module.exports = __webpack_public_path__ + "img/e8d8bb556cf9ad1d4ef6fcc5af87efa.b957a2b9.png";